// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Vendor model relations belongsTo relations 1`] = `
Array [
  "BidGroupVendor",
  "VendorCategory",
  "Vendor",
  "Location",
]
`;

exports[`Vendor model relations hasMany relations 1`] = `
Array [
  "VendorContact",
  "Discount",
]
`;
